import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { AgreementConditionType, AgreementTypeEnum } from "__generated__/graphql";
import { useApolloClient } from "@apollo/client";
import { getCompatibleConditionsByAgreementType_query } from "view/agreements/utils/AgreementQueries";

const AgreementConditionTypeSelect = ({ agreementType, value, onChange, getOptionDisabled }: Omit<SelectProps<AgreementConditionType, false>, "fetchOptions"> & { agreementType: AgreementTypeEnum; }) => {
	const client = useApolloClient();

	const onFetchOptions = async() => {
		try {
			const result = await client.query({
				query: getCompatibleConditionsByAgreementType_query,
				variables: {
					agreementType: agreementType,
				},
			});

			return {
				options: result.data.compatibleConditionsByAgreementType ?? [],
				totalResults: result.data.compatibleConditionsByAgreementType?.length ?? 0,
			};
		} catch (ex) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			getOptionDisabled={getOptionDisabled}
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `AGREEMENT_CONDITION_TYPE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default AgreementConditionTypeSelect;
